import { PaymentProvider } from 'src/services/helpers/payment'

export function orderPaymentProviderIdsForCountry(
  providerIds: readonly PaymentProvider[],
  country?: string,
): PaymentProvider[] {
  const orderedProviderIds = [...providerIds]
  if (country !== 'HK') return orderedProviderIds

  const wechatPayIndex = orderedProviderIds.indexOf(
    PaymentProvider.onerwayWechatPay,
  )
  const googlePayIndex = orderedProviderIds.indexOf(
    PaymentProvider.onerwayGooglePay,
  )

  if (wechatPayIndex === -1 || googlePayIndex === -1) {
    return orderedProviderIds
  }

  orderedProviderIds[wechatPayIndex] = PaymentProvider.onerwayGooglePay
  orderedProviderIds[googlePayIndex] = PaymentProvider.onerwayWechatPay

  return orderedProviderIds
}
